import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DaySliderComponent } from './day-slider.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-day-slider-example',
  template: `
    <div class="p-4">
      <h2 class="text-xl font-bold mb-4">Day Slider with Calendar Icon</h2>
      <app-day-slider 
        [showCalendarIcon]="true"
        [disablePastDays]="true"
        (dateSelected)="onDateSelected($event)">
      </app-day-slider>
      
      <div class="mt-8">
        <h2 class="text-xl font-bold mb-4">Day Slider without Calendar Icon</h2>
        <app-day-slider 
          [showCalendarIcon]="false"
          [disablePastDays]="false"
          (dateSelected)="onDateSelected($event)">
        </app-day-slider>
      </div>
      
      <div class="mt-4 p-4 bg-gray-100 rounded">
        <p>Selected date: {{ selectedDate | date:'fullDate' }}</p>
      </div>
    </div>
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DaySliderComponent, CommonModule]
})
export class DaySliderExampleComponent {
  selectedDate: Date = new Date();
  
  onDateSelected(date: Date): void {
    this.selectedDate = date;
    console.log('Selected date:', date);
  }
}